<template>
  <bly-permission-field :label="label" :hint="hint" :error="error" :required="required">
    <textarea
      :value="value"
      :placeholder="placeholder"
      :rows="rows"
      class="min-h-[88px] w-full resize-y rounded-sm border bg-black/20 px-2.5 py-2 text-xs text-[#e5eefc] transition-[border-color,box-shadow] duration-150 outline-none"
      :class="error ? 'border-[#ff8a65]' : 'border-[#2a333d] focus:border-[#ffaa00] focus:shadow-[0_0_0_2px_rgba(255,170,0,0.18)]'"
      @input="$emit('input', $event.target.value)"
    />
  </bly-permission-field>
</template>

<script>
export default {
  name: "NativeTextareaField",
  props: {
    value: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    rows: {
      type: Number,
      default: 3,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
